export default {
  CURRENT_USER_REPOSITORY: Symbol.for('CURRENT_USER_REPOSITORY'),
  GET_CURRENT_USER_QUERY: Symbol.for('GET_CURRENT_USER_QUERY'),
};
